import { render, staticRenderFns } from "./product-info.vue?vue&type=template&id=a7fc38aa&"
import script from "./product-info.vue?vue&type=script&lang=js&"
export * from "./product-info.vue?vue&type=script&lang=js&"
import style0 from "./product-info.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/funday/funday/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('a7fc38aa')) {
      api.createRecord('a7fc38aa', component.options)
    } else {
      api.reload('a7fc38aa', component.options)
    }
    module.hot.accept("./product-info.vue?vue&type=template&id=a7fc38aa&", function () {
      api.rerender('a7fc38aa', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "frontend/src/components/product/product-info.vue"
export default component.exports